export const fr = {
  selectStore: 'Sélectionner un magasin',
  product: 'Produit',
  image: 'Image',
  store: 'Magasin',
  actions: 'Actions',
  stockState: 'État de stock',
  quantity: 'Quantité',
  totalQuantity: 'Quantité totale',
  lastMovement: 'Dernier mouvement',
  manualDescription: 'Description manuelle',
  saveMovement: 'Enregistrer le mouvement',
  noResults: 'Aucun résultat',
  loading: 'Chargement…',
  error: 'Une erreur est survenue',
  search: 'Rechercher',
  refresh: 'Rafraîchir',
  clear: 'Effacer',
  cancel: 'Annuler',
  validate: 'Valider',
  description: 'Description',
  price: 'Prix',
  addProduct: 'Ajouter un produit',
  success: 'Mouvement enregistré',
  balanceTitle: 'Balances d’inventaire',
  agingTitle: "Ancienneté de l’inventaire",
  flowTitle: 'Flux des mouvements',
  historyTitle: (productLabel: string) =>
    `Historique du produit ${productLabel ?? ''}`.trim(),
  openMovement: (movementLabel: string) =>
    `Ouvrir le formulaire ${movementLabel.toLowerCase()}`,
  confirmMovement: (movementLabel: string) =>
    `Valider ${movementLabel.toLowerCase()}`,
  useProduct: 'Sélectionner',
  viewDetails: 'Voir les détails',
  close: 'Fermer',
  stockStateSummary: 'Répartition par état de stock',
  detailsTitle: (productLabel: string) =>
    `Détails de l’inventaire ${productLabel ?? ''}`.trim(),
  openMovementHelper:
    'Choisissez une action pour accélérer le traitement du produit sélectionné.',
  printBarcode: 'Imprimer le code-barres',
  printBarcodePriceQuestion: 'Afficher le prix sur l’étiquette ?',
  missingBarcode: 'Aucun code-barres disponible',
  yes: 'Oui',
  no: 'Non',
  searchBalancePlaceholder: 'Rechercher par nom ou code-barres…',
  correctedPositive: 'Corrigé (+)',
  correctedNegative: 'Corrigé (-)',
  recycled: 'Recyclé',
  availableStockLabel: 'Stock disponible',
  availableStockFallbackStore: 'le magasin sélectionné',
  availableStockDescription: (storeName?: string) =>
    `Quantité disponible dans ${storeName || 'le magasin sélectionné'}`,
  storeAvailability: 'Stock du magasin sélectionné',
  availableStockPerStore: (storeName?: string) =>
    `Disponible (${storeName || 'magasin sélectionné'})`,
  outsideSelectedStore: 'Produit hors magasin sélectionné',
  productsPerPage: 'Produits par page',
  paginationDisplayedRows: ({
    from,
    to,
    count,
  }: {
    from: number;
    to: number;
    count: number;
  }) => `${from}–${to} sur ${count === -1 ? `plus de ${to}` : count}`,
};
